import React, {useEffect,useRef} from 'react'
import {  isMobile } from 'react-device-detect';
import '../css/style.css'
import '../css/media.css'
import '../css/jquery-ui.structure.min.css'
import '../css/jquery-ui.theme.min.css'
import '../css/owl.carousel.min.css'
import '../css/owl.theme.default.min.css'
import '../css/font-awesome.min.css'
import  LOGO from '../images/logo1.png'
import  MOBILELOGO from '../images/yes.png'

const Header = () => {
   

  const mobileMenu = useRef('')


  useEffect(()=>{

    if(isMobile){
    mobileMenu.current.style.display = "none"
    }
  },[])



 const menuToggle = () => {
    if(mobileMenu.current.style.display === "none"){
      mobileMenu.current.style.display = "block"
      
    }else{
      mobileMenu.current.style.display = "none"
    }

 }


    return(
      <header id="home">

      {/*<!-- THE DESKTOP VERSION OF THE HEADER-->*/}
        <div className="container">
         <div className="top-bar"> 
           <div className="nav-col">
               
           <div className="logo">
                   <img src={LOGO} className="img-responsive" alt="bridgeway logo"/>
               </div> 
               {/*<!-- logo closing tag-->*/}
               
               <div className="menu">
                <a href="https://bridgewaymfb.com/#welcome">See Balance</a>
                <a href="https://bridgewaymfb.com/#why-choose-us">About Us</a>
                <a href="https://bridgewaymfb.com/#bank-careers">Available Jobs</a>
                <a href="https://bridgewaymfb.com/#feature-sec">Products</a>
                <a href="https://bridgewaymfb.com/#expand">Spotlight</a>
                <a href="https://bridgewaymfb.com/#contact">Contact Us</a>
               </div>
            
  
              
               {/*<!--menu closing tag-->*/}
           </div>
              {/*<!--the nav col closing tag-->*/}
  
  
               
               <div className="num-info-col">
                <a href="tel:0818376331"><span>Call Us:</span>08152222536</a>  
               </div>   {/*<!--num-info-col closing tag-->*/}
  
              {/*<!-- THE DESKTOP VERSION OF THE HEADER ENDING-->*/}
  
              {/*<!--  THE MOBILE VERSION OF THE HEADER ! (below)-->*/}
  
                 
              <div class="almost-center">
                 <div className="cnt-info-col" id="mobile-hamburger">
                  <button type="button" id="toggle-bar" onClick={menuToggle}><span><img src={MOBILELOGO}  class="img-responsive bway-mobile-logo" alt="bridgeway logo"/></span> MENU</button>
                </div> {/*<!--hamburger's closing tag-->*/}
              </div>
  
  
                <div className="clear"> </div> {/*<!--clear closing tag-->*/}
  
                <div className="menu " id="mobile-menu" ref ={mobileMenu}>
                  <a  href="https://bridgewaymfb.com/#home" className="rollup">See Balance</a>
                  <a href="https://bridgewaymfb.com/#why-choose-us" className="rollup">About Us</a>
                  <a href="https://bridgewaymfb.com/#bank-careers" className="rollup">Available Jobs</a>
                  <a href="https://bridgewaymfb.com/#feature-sec" className="rollup">Products</a>
                  <a href="https://bridgewaymfb.com/#expand" className="rollup">Spotlight</a>
                  <a href="https://bridgewaymfb.com/#contact" className="rollup">Contact Us</a>
                  <a href="tel:08152222536" className="rollup">Call: 08152222536</a>
                </div>
  
           </div> {/*<!--top-bar closing tag-->*/}
         
              {/*<!-- THE MOBILE VERSION OF THE HEADER ENDING-->*/}
        </div>
    </header>
    )
}

export default Header

